export const COLORS = {
  home: '#4DD0E1',
  showcase: '#f27573',
  background: '#81c784',
  contact: '#ffab41',
};
